module.exports = __webpack_public_path__ + "static/media/registrationImage.9ecc3fe5.png";